import { render, staticRenderFns } from "./Flavours.vue?vue&type=template&id=27735127"
import script from "./Flavours.vue?vue&type=script&lang=js"
export * from "./Flavours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports